// Calculs purs de l'interface patrimoine (testés par calc.test.ts). Le serveur refait toujours les contrôles.

/** Nombre facultatif saisi dans un champ texte (virgule acceptée) : vide → null, invalide → NaN. */
export function numOrNull(v: string): number | null {
  const t = v.trim().replace(",", ".");
  if (!t) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : NaN;
}

export function intOrNull(v: string): number | null {
  const n = numOrNull(v);
  return n === null ? null : Number.isNaN(n) ? NaN : Math.trunc(n);
}

/** Quote-part saisie en pour cent → millièmes de pour cent (100 % = 100 000). */
export function toMilli(v: string): number | null {
  const n = numOrNull(v);
  if (n === null || Number.isNaN(n)) return null;
  return Math.round(n * 1000);
}

/** Millièmes → « 33,334 % ». */
export function milliLabel(m: number): string {
  return `${(m / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 3 })} %`;
}

/** Parts égales sans perte de millième : 3 personnes → 33,334 / 33,333 / 33,333. */
export function equalShares(n: number): string[] {
  if (n <= 0) return [];
  const base = Math.floor(100000 / n);
  let rest = 100000 - base * n;
  return Array.from({ length: n }, () => {
    const m = base + (rest-- > 0 ? 1 : 0);
    return (m / 1000).toLocaleString("fr-FR", { maximumFractionDigits: 3, useGrouping: false });
  });
}

/** Somme des quotes-parts saisies, en millièmes. */
export function sharesTotal(values: string[]): number {
  return values.reduce((acc, v) => acc + (toMilli(v) ?? 0), 0);
}
